
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue?macro=true";
import { default as agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue?macro=true";
import { default as cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue?macro=true";
import { default as test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue?macro=true";
import { default as loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue?macro=true";
import { default as searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue?macro=true";
import { default as barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue?macro=true";
import { default as imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue?macro=true";
import { default as welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue?macro=true";
import { default as registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue?macro=true";
import { default as campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue?macro=true";
import { default as suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue?macro=true";
import { default as gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue?macro=true";
import { default as ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue?macro=true";
import { default as datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue?macro=true";
import { default as _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue?macro=true";
import { default as ceva6nYt0gUqxTbQs_45DwHLzkYMgAxKuINW6iyyADHK6Ip90Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ceva.vue?macro=true";
import { default as heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue?macro=true";
import { default as testyl_459RG9cDF7KWH7AQ0PHGFTfso48_Ft0xzaOQE2utM0Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/test.vue?macro=true";
import { default as order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue?macro=true";
import { default as _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue?macro=true";
import { default as _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue?macro=true";
import { default as hanseYow_Az2TvWhQb804r2GLOSkUn3X_cMa6EgsSNGGL0yUMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hanse.vue?macro=true";
import { default as reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue?macro=true";
import { default as _91id_93cGVpGy3l1m8W83M5NZPim9QK4DiOaTO0WZr7khDmTJkMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[id].vue?macro=true";
import { default as profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue?macro=true";
import { default as dodermsaJBtS60c7gSKM7kZl3P_45BUMjyVP4eqfVibPtS1LZ5gMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/doderm.vue?macro=true";
import { default as InuvetW5k_G4yYV9GvRj70ELViewpmr3ty_45wtTJ27r2nK1LmoMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/Inuvet.vue?macro=true";
import { default as remendLlcwVFJhshCvrxLg76hDN5PPcYGGwX44hbYavsCyoa8Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/remend.vue?macro=true";
import { default as tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue?macro=true";
import { default as virbacuaTrsYoISKKJT2SXcGdXSSa1Y60Vm7kwLrVGoDDaUG4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac.vue?macro=true";
import { default as ziapamsJm1XM1_45Ucd2ESKC1XE3MJUw0ZlrL1_cdN8_45fAymhSAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ziapam.vue?macro=true";
import { default as forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue?macro=true";
import { default as indexv63V3y3iR6HEvkC39YYeXWArpcDPa_45WnAaZYOqwumjAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/index.vue?macro=true";
import { default as inuvet2uTfgfpeSP__45MhtC_4583qgLEpKqIhVJ6gevkX0Kqhvba4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet2.vue?macro=true";
import { default as inuvet30qwDNadyZXgTcYlOX17w4lTObH0n_4DnwyRWqvGZBgkMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet3.vue?macro=true";
import { default as virbac2yY9pEkgUAbocyZewNAhVrzQnnKNfnIhJ_45WGwz_45KzXJAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac2.vue?macro=true";
import { default as profilex9oRRvEXFzkuEyN_45fNHcXWuOMvuoDYe3cSXyIE3ynCEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/internal/profile.vue?macro=true";
import { default as duomyxinUa5aZJrGcJY1HgRkyFRz_kq77v3Uggwj2rJytfSHk0gMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/duomyxin.vue?macro=true";
import { default as product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue?macro=true";
import { default as references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue?macro=true";
import { default as indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue?macro=true";
import { default as _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue?macro=true";
import { default as boehringertfUdBwXiHL7JeMlqlqwKcQCxtN5bSE0mCUniKNkaBBwMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/boehringer.vue?macro=true";
import { default as millpledgePfX5rzs_qWkqdZHhbQRe4Di5bIf35Mi0GcGxWR5fZToMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/millpledge.vue?macro=true";
import { default as _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue?macro=true";
import { default as _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue?macro=true";
import { default as _91_46_46_46fallback_93VUYhQ2qvnPETwbxbYwyWxCs6aKA3RyFtlM_453rFX4skoMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[...fallback].vue?macro=true";
import { default as affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "agb___de",
    path: "/de/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "agb___en",
    path: "/en/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "agb___fr",
    path: "/fr/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "agb___es",
    path: "/es/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "cart___es",
    path: "/es/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "test___de",
    path: "/de/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "test___fr",
    path: "/fr/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "test___es",
    path: "/es/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    meta: searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "barcode___de",
    path: "/de/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "barcode___en",
    path: "/en/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "barcode___fr",
    path: "/fr/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "barcode___es",
    path: "/es/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "imprint___de",
    path: "/de/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "imprint___en",
    path: "/en/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "imprint___fr",
    path: "/fr/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "imprint___es",
    path: "/es/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "welcome___de",
    path: "/de/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "welcome___en",
    path: "/en/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "welcome___fr",
    path: "/fr/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "welcome___es",
    path: "/es/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "campaigns___de",
    path: "/de/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "campaigns___en",
    path: "/en/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "campaigns___fr",
    path: "/fr/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "campaigns___es",
    path: "/es/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "suppliers___de",
    path: "/de/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "suppliers___en",
    path: "/en/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "suppliers___fr",
    path: "/fr/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "suppliers___es",
    path: "/es/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "gutscheine___de",
    path: "/de/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "gutscheine___en",
    path: "/en/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "gutscheine___fr",
    path: "/fr/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "gutscheine___es",
    path: "/es/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "campaign-ims___de",
    path: "/de/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "campaign-ims___en",
    path: "/en/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "campaign-ims___fr",
    path: "/fr/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "campaign-ims___es",
    path: "/es/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "datasecurity___de",
    path: "/de/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "datasecurity___en",
    path: "/en/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "datasecurity___fr",
    path: "/fr/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "datasecurity___es",
    path: "/es/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "fallback___de",
    path: "/de/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "fallback___en",
    path: "/en/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "fallback___fr",
    path: "/fr/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "fallback___es",
    path: "/es/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "campaign-ceva___de",
    path: "/de/campaign/ceva",
    meta: ceva6nYt0gUqxTbQs_45DwHLzkYMgAxKuINW6iyyADHK6Ip90Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ceva.vue")
  },
  {
    name: "campaign-ceva___en",
    path: "/en/campaign/ceva",
    meta: ceva6nYt0gUqxTbQs_45DwHLzkYMgAxKuINW6iyyADHK6Ip90Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ceva.vue")
  },
  {
    name: "campaign-ceva___fr",
    path: "/fr/campaign/ceva",
    meta: ceva6nYt0gUqxTbQs_45DwHLzkYMgAxKuINW6iyyADHK6Ip90Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ceva.vue")
  },
  {
    name: "campaign-ceva___es",
    path: "/es/campaign/ceva",
    meta: ceva6nYt0gUqxTbQs_45DwHLzkYMgAxKuINW6iyyADHK6Ip90Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ceva.vue")
  },
  {
    name: "campaign-heel___de",
    path: "/de/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-heel___en",
    path: "/en/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-heel___fr",
    path: "/fr/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-heel___es",
    path: "/es/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-test___de",
    path: "/de/campaign/test",
    meta: testyl_459RG9cDF7KWH7AQ0PHGFTfso48_Ft0xzaOQE2utM0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/test.vue")
  },
  {
    name: "campaign-test___en",
    path: "/en/campaign/test",
    meta: testyl_459RG9cDF7KWH7AQ0PHGFTfso48_Ft0xzaOQE2utM0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/test.vue")
  },
  {
    name: "campaign-test___fr",
    path: "/fr/campaign/test",
    meta: testyl_459RG9cDF7KWH7AQ0PHGFTfso48_Ft0xzaOQE2utM0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/test.vue")
  },
  {
    name: "campaign-test___es",
    path: "/es/campaign/test",
    meta: testyl_459RG9cDF7KWH7AQ0PHGFTfso48_Ft0xzaOQE2utM0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/test.vue")
  },
  {
    name: "order-history___de",
    path: "/de/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "order-history___en",
    path: "/en/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "order-history___fr",
    path: "/fr/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "order-history___es",
    path: "/es/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "s-orders-id___de",
    path: "/de/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "s-orders-id___en",
    path: "/en/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "s-orders-id___fr",
    path: "/fr/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "s-orders-id___es",
    path: "/es/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "supplier-id___de",
    path: "/de/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___en",
    path: "/en/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___fr",
    path: "/fr/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___es",
    path: "/es/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "campaign-hanse___de",
    path: "/de/campaign/hanse",
    meta: hanseYow_Az2TvWhQb804r2GLOSkUn3X_cMa6EgsSNGGL0yUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hanse.vue")
  },
  {
    name: "campaign-hanse___en",
    path: "/en/campaign/hanse",
    meta: hanseYow_Az2TvWhQb804r2GLOSkUn3X_cMa6EgsSNGGL0yUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hanse.vue")
  },
  {
    name: "campaign-hanse___fr",
    path: "/fr/campaign/hanse",
    meta: hanseYow_Az2TvWhQb804r2GLOSkUn3X_cMa6EgsSNGGL0yUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hanse.vue")
  },
  {
    name: "campaign-hanse___es",
    path: "/es/campaign/hanse",
    meta: hanseYow_Az2TvWhQb804r2GLOSkUn3X_cMa6EgsSNGGL0yUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hanse.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "reset-password___es",
    path: "/es/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "category-id___de",
    path: "/de/:category()/:id()",
    meta: _91id_93cGVpGy3l1m8W83M5NZPim9QK4DiOaTO0WZr7khDmTJkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[id].vue")
  },
  {
    name: "category-id___en",
    path: "/en/:category()/:id()",
    meta: _91id_93cGVpGy3l1m8W83M5NZPim9QK4DiOaTO0WZr7khDmTJkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[id].vue")
  },
  {
    name: "category-id___fr",
    path: "/fr/:category()/:id()",
    meta: _91id_93cGVpGy3l1m8W83M5NZPim9QK4DiOaTO0WZr7khDmTJkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[id].vue")
  },
  {
    name: "category-id___es",
    path: "/es/:category()/:id()",
    meta: _91id_93cGVpGy3l1m8W83M5NZPim9QK4DiOaTO0WZr7khDmTJkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[id].vue")
  },
  {
    name: "account-profile___de",
    path: "/de/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___en",
    path: "/en/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___es",
    path: "/es/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "campaign-doderm___de",
    path: "/de/campaign/doderm",
    meta: dodermsaJBtS60c7gSKM7kZl3P_45BUMjyVP4eqfVibPtS1LZ5gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/doderm.vue")
  },
  {
    name: "campaign-doderm___en",
    path: "/en/campaign/doderm",
    meta: dodermsaJBtS60c7gSKM7kZl3P_45BUMjyVP4eqfVibPtS1LZ5gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/doderm.vue")
  },
  {
    name: "campaign-doderm___fr",
    path: "/fr/campaign/doderm",
    meta: dodermsaJBtS60c7gSKM7kZl3P_45BUMjyVP4eqfVibPtS1LZ5gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/doderm.vue")
  },
  {
    name: "campaign-doderm___es",
    path: "/es/campaign/doderm",
    meta: dodermsaJBtS60c7gSKM7kZl3P_45BUMjyVP4eqfVibPtS1LZ5gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/doderm.vue")
  },
  {
    name: "campaign-Inuvet___de",
    path: "/de/campaign/Inuvet",
    meta: InuvetW5k_G4yYV9GvRj70ELViewpmr3ty_45wtTJ27r2nK1LmoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/Inuvet.vue")
  },
  {
    name: "campaign-Inuvet___en",
    path: "/en/campaign/Inuvet",
    meta: InuvetW5k_G4yYV9GvRj70ELViewpmr3ty_45wtTJ27r2nK1LmoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/Inuvet.vue")
  },
  {
    name: "campaign-Inuvet___fr",
    path: "/fr/campaign/Inuvet",
    meta: InuvetW5k_G4yYV9GvRj70ELViewpmr3ty_45wtTJ27r2nK1LmoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/Inuvet.vue")
  },
  {
    name: "campaign-Inuvet___es",
    path: "/es/campaign/Inuvet",
    meta: InuvetW5k_G4yYV9GvRj70ELViewpmr3ty_45wtTJ27r2nK1LmoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/Inuvet.vue")
  },
  {
    name: "campaign-remend___de",
    path: "/de/campaign/remend",
    meta: remendLlcwVFJhshCvrxLg76hDN5PPcYGGwX44hbYavsCyoa8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/remend.vue")
  },
  {
    name: "campaign-remend___en",
    path: "/en/campaign/remend",
    meta: remendLlcwVFJhshCvrxLg76hDN5PPcYGGwX44hbYavsCyoa8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/remend.vue")
  },
  {
    name: "campaign-remend___fr",
    path: "/fr/campaign/remend",
    meta: remendLlcwVFJhshCvrxLg76hDN5PPcYGGwX44hbYavsCyoa8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/remend.vue")
  },
  {
    name: "campaign-remend___es",
    path: "/es/campaign/remend",
    meta: remendLlcwVFJhshCvrxLg76hDN5PPcYGGwX44hbYavsCyoa8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/remend.vue")
  },
  {
    name: "campaign-tessie___de",
    path: "/de/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-tessie___en",
    path: "/en/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-tessie___fr",
    path: "/fr/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-tessie___es",
    path: "/es/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-virbac___de",
    path: "/de/campaign/virbac",
    meta: virbacuaTrsYoISKKJT2SXcGdXSSa1Y60Vm7kwLrVGoDDaUG4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac.vue")
  },
  {
    name: "campaign-virbac___en",
    path: "/en/campaign/virbac",
    meta: virbacuaTrsYoISKKJT2SXcGdXSSa1Y60Vm7kwLrVGoDDaUG4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac.vue")
  },
  {
    name: "campaign-virbac___fr",
    path: "/fr/campaign/virbac",
    meta: virbacuaTrsYoISKKJT2SXcGdXSSa1Y60Vm7kwLrVGoDDaUG4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac.vue")
  },
  {
    name: "campaign-virbac___es",
    path: "/es/campaign/virbac",
    meta: virbacuaTrsYoISKKJT2SXcGdXSSa1Y60Vm7kwLrVGoDDaUG4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac.vue")
  },
  {
    name: "campaign-ziapam___de",
    path: "/de/campaign/ziapam",
    meta: ziapamsJm1XM1_45Ucd2ESKC1XE3MJUw0ZlrL1_cdN8_45fAymhSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ziapam.vue")
  },
  {
    name: "campaign-ziapam___en",
    path: "/en/campaign/ziapam",
    meta: ziapamsJm1XM1_45Ucd2ESKC1XE3MJUw0ZlrL1_cdN8_45fAymhSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ziapam.vue")
  },
  {
    name: "campaign-ziapam___fr",
    path: "/fr/campaign/ziapam",
    meta: ziapamsJm1XM1_45Ucd2ESKC1XE3MJUw0ZlrL1_cdN8_45fAymhSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ziapam.vue")
  },
  {
    name: "campaign-ziapam___es",
    path: "/es/campaign/ziapam",
    meta: ziapamsJm1XM1_45Ucd2ESKC1XE3MJUw0ZlrL1_cdN8_45fAymhSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ziapam.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "category___de",
    path: "/de/:category()",
    meta: indexv63V3y3iR6HEvkC39YYeXWArpcDPa_45WnAaZYOqwumjAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/index.vue")
  },
  {
    name: "category___en",
    path: "/en/:category()",
    meta: indexv63V3y3iR6HEvkC39YYeXWArpcDPa_45WnAaZYOqwumjAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/index.vue")
  },
  {
    name: "category___fr",
    path: "/fr/:category()",
    meta: indexv63V3y3iR6HEvkC39YYeXWArpcDPa_45WnAaZYOqwumjAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/index.vue")
  },
  {
    name: "category___es",
    path: "/es/:category()",
    meta: indexv63V3y3iR6HEvkC39YYeXWArpcDPa_45WnAaZYOqwumjAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/index.vue")
  },
  {
    name: "campaign-inuvet2___de",
    path: "/de/campaign/inuvet2",
    meta: inuvet2uTfgfpeSP__45MhtC_4583qgLEpKqIhVJ6gevkX0Kqhvba4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet2.vue")
  },
  {
    name: "campaign-inuvet2___en",
    path: "/en/campaign/inuvet2",
    meta: inuvet2uTfgfpeSP__45MhtC_4583qgLEpKqIhVJ6gevkX0Kqhvba4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet2.vue")
  },
  {
    name: "campaign-inuvet2___fr",
    path: "/fr/campaign/inuvet2",
    meta: inuvet2uTfgfpeSP__45MhtC_4583qgLEpKqIhVJ6gevkX0Kqhvba4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet2.vue")
  },
  {
    name: "campaign-inuvet2___es",
    path: "/es/campaign/inuvet2",
    meta: inuvet2uTfgfpeSP__45MhtC_4583qgLEpKqIhVJ6gevkX0Kqhvba4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet2.vue")
  },
  {
    name: "campaign-inuvet3___de",
    path: "/de/campaign/inuvet3",
    meta: inuvet30qwDNadyZXgTcYlOX17w4lTObH0n_4DnwyRWqvGZBgkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet3.vue")
  },
  {
    name: "campaign-inuvet3___en",
    path: "/en/campaign/inuvet3",
    meta: inuvet30qwDNadyZXgTcYlOX17w4lTObH0n_4DnwyRWqvGZBgkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet3.vue")
  },
  {
    name: "campaign-inuvet3___fr",
    path: "/fr/campaign/inuvet3",
    meta: inuvet30qwDNadyZXgTcYlOX17w4lTObH0n_4DnwyRWqvGZBgkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet3.vue")
  },
  {
    name: "campaign-inuvet3___es",
    path: "/es/campaign/inuvet3",
    meta: inuvet30qwDNadyZXgTcYlOX17w4lTObH0n_4DnwyRWqvGZBgkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/inuvet3.vue")
  },
  {
    name: "campaign-virbac2___de",
    path: "/de/campaign/virbac2",
    meta: virbac2yY9pEkgUAbocyZewNAhVrzQnnKNfnIhJ_45WGwz_45KzXJAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac2.vue")
  },
  {
    name: "campaign-virbac2___en",
    path: "/en/campaign/virbac2",
    meta: virbac2yY9pEkgUAbocyZewNAhVrzQnnKNfnIhJ_45WGwz_45KzXJAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac2.vue")
  },
  {
    name: "campaign-virbac2___fr",
    path: "/fr/campaign/virbac2",
    meta: virbac2yY9pEkgUAbocyZewNAhVrzQnnKNfnIhJ_45WGwz_45KzXJAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac2.vue")
  },
  {
    name: "campaign-virbac2___es",
    path: "/es/campaign/virbac2",
    meta: virbac2yY9pEkgUAbocyZewNAhVrzQnnKNfnIhJ_45WGwz_45KzXJAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/virbac2.vue")
  },
  {
    name: "internal-profile___de",
    path: "/de/internal/profile",
    meta: profilex9oRRvEXFzkuEyN_45fNHcXWuOMvuoDYe3cSXyIE3ynCEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/internal/profile.vue")
  },
  {
    name: "internal-profile___en",
    path: "/en/internal/profile",
    meta: profilex9oRRvEXFzkuEyN_45fNHcXWuOMvuoDYe3cSXyIE3ynCEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/internal/profile.vue")
  },
  {
    name: "internal-profile___fr",
    path: "/fr/internal/profile",
    meta: profilex9oRRvEXFzkuEyN_45fNHcXWuOMvuoDYe3cSXyIE3ynCEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/internal/profile.vue")
  },
  {
    name: "internal-profile___es",
    path: "/es/internal/profile",
    meta: profilex9oRRvEXFzkuEyN_45fNHcXWuOMvuoDYe3cSXyIE3ynCEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/internal/profile.vue")
  },
  {
    name: "campaign-duomyxin___de",
    path: "/de/campaign/duomyxin",
    meta: duomyxinUa5aZJrGcJY1HgRkyFRz_kq77v3Uggwj2rJytfSHk0gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/duomyxin.vue")
  },
  {
    name: "campaign-duomyxin___en",
    path: "/en/campaign/duomyxin",
    meta: duomyxinUa5aZJrGcJY1HgRkyFRz_kq77v3Uggwj2rJytfSHk0gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/duomyxin.vue")
  },
  {
    name: "campaign-duomyxin___fr",
    path: "/fr/campaign/duomyxin",
    meta: duomyxinUa5aZJrGcJY1HgRkyFRz_kq77v3Uggwj2rJytfSHk0gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/duomyxin.vue")
  },
  {
    name: "campaign-duomyxin___es",
    path: "/es/campaign/duomyxin",
    meta: duomyxinUa5aZJrGcJY1HgRkyFRz_kq77v3Uggwj2rJytfSHk0gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/duomyxin.vue")
  },
  {
    name: "product-favorites___de",
    path: "/de/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "product-favorites___en",
    path: "/en/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "product-favorites___fr",
    path: "/fr/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "product-favorites___es",
    path: "/es/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "account-references___de",
    path: "/de/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "account-references___en",
    path: "/en/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "account-references___fr",
    path: "/fr/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "account-references___es",
    path: "/es/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "clinic-chain___de",
    path: "/de/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "clinic-chain___en",
    path: "/en/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "clinic-chain___fr",
    path: "/fr/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "clinic-chain___es",
    path: "/es/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "order-confirm-id___de",
    path: "/de/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "order-confirm-id___en",
    path: "/en/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "order-confirm-id___fr",
    path: "/fr/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "order-confirm-id___es",
    path: "/es/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "campaign-boehringer___de",
    path: "/de/campaign/boehringer",
    meta: boehringertfUdBwXiHL7JeMlqlqwKcQCxtN5bSE0mCUniKNkaBBwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/boehringer.vue")
  },
  {
    name: "campaign-boehringer___en",
    path: "/en/campaign/boehringer",
    meta: boehringertfUdBwXiHL7JeMlqlqwKcQCxtN5bSE0mCUniKNkaBBwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/boehringer.vue")
  },
  {
    name: "campaign-boehringer___fr",
    path: "/fr/campaign/boehringer",
    meta: boehringertfUdBwXiHL7JeMlqlqwKcQCxtN5bSE0mCUniKNkaBBwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/boehringer.vue")
  },
  {
    name: "campaign-boehringer___es",
    path: "/es/campaign/boehringer",
    meta: boehringertfUdBwXiHL7JeMlqlqwKcQCxtN5bSE0mCUniKNkaBBwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/boehringer.vue")
  },
  {
    name: "campaign-millpledge___de",
    path: "/de/campaign/millpledge",
    meta: millpledgePfX5rzs_qWkqdZHhbQRe4Di5bIf35Mi0GcGxWR5fZToMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/millpledge.vue")
  },
  {
    name: "campaign-millpledge___en",
    path: "/en/campaign/millpledge",
    meta: millpledgePfX5rzs_qWkqdZHhbQRe4Di5bIf35Mi0GcGxWR5fZToMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/millpledge.vue")
  },
  {
    name: "campaign-millpledge___fr",
    path: "/fr/campaign/millpledge",
    meta: millpledgePfX5rzs_qWkqdZHhbQRe4Di5bIf35Mi0GcGxWR5fZToMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/millpledge.vue")
  },
  {
    name: "campaign-millpledge___es",
    path: "/es/campaign/millpledge",
    meta: millpledgePfX5rzs_qWkqdZHhbQRe4Di5bIf35Mi0GcGxWR5fZToMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/millpledge.vue")
  },
  {
    name: "country-fallback___de",
    path: "/de/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "country-fallback___en",
    path: "/en/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "country-fallback___fr",
    path: "/fr/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "country-fallback___es",
    path: "/es/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "product-supplier-id___de",
    path: "/de/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "product-supplier-id___en",
    path: "/en/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "product-supplier-id___fr",
    path: "/fr/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "product-supplier-id___es",
    path: "/es/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "category-fallback___de",
    path: "/de/:category()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VUYhQ2qvnPETwbxbYwyWxCs6aKA3RyFtlM_453rFX4skoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[...fallback].vue")
  },
  {
    name: "category-fallback___en",
    path: "/en/:category()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VUYhQ2qvnPETwbxbYwyWxCs6aKA3RyFtlM_453rFX4skoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[...fallback].vue")
  },
  {
    name: "category-fallback___fr",
    path: "/fr/:category()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VUYhQ2qvnPETwbxbYwyWxCs6aKA3RyFtlM_453rFX4skoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[...fallback].vue")
  },
  {
    name: "category-fallback___es",
    path: "/es/:category()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VUYhQ2qvnPETwbxbYwyWxCs6aKA3RyFtlM_453rFX4skoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[category]/[...fallback].vue")
  },
  {
    name: "clinic-chain-affiliation___de",
    path: "/de/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  },
  {
    name: "clinic-chain-affiliation___en",
    path: "/en/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  },
  {
    name: "clinic-chain-affiliation___fr",
    path: "/fr/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  },
  {
    name: "clinic-chain-affiliation___es",
    path: "/es/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  }
]